<ng-container *ngIf="translate$|async"></ng-container>
<ng-container *ngIf="userAttributes$|async"></ng-container>

<div id="App" [ngClass]="{'hide-menu' : hideMenu}" >

  <ng-container *ngIf="notificationStatus$|async"></ng-container>
  <nb-layout [ngClass]="{'nb-layout-iframe':iframeService?.isInIframe}">
    <nb-layout-header fixed *ngIf="!hideMenu" [ngClass]="{'nb-layout-header-hide':iframeService?.isInIframe}">
      <div id="header-bar" *ngIf="!iframeService?.isInIframe">
        <div class="env-notice" *ngIf="env">This is a {{env}} Environment</div>
        <div class="scaffold-toolbar" >
          <button nbButton status="basic" size="giant" appearance="ghost" class="header-button scaffold-menu-toggle" (click)=leftNavtoggle() aria-label="Toggle Scaffold menu visibility">
            <nb-icon pack="fas" icon="bars"></nb-icon>
          </button>
          <a routerLink="/home"><img id="school-logo" src="school-assets/school_logo.png" alt="Navigate to landing page link image"></a>
          <span class="header-padding"></span>
          <app-scaffold-type [selected]="selectedType" (changed)="setInstance($event)" label="Product:"></app-scaffold-type>
          
          <div class="notification-button-wrapper">
            <nb-badge [text]="activeNotificationCount" status="primary"  *ngIf="activeNotificationCount!=0"  position="top left"></nb-badge>
            <div class="notification-button-container" [class.active-notifications]="activeNotificationCount!=0">
            <button style="background: transparent;" nbButton appearance="ghost" (click)="openNotifications()">
              <nb-icon pack="fas" icon="bell"></nb-icon>
            </button>
          </div>
          </div>
          <div>
            <scaffold-toggle-slide [(ngModel)]="itemsService.autosave" status="info" size="small" name="autosave" ngDefaultControl>{{'autosave'| translation|transformText:'capitalize'}}</scaffold-toggle-slide>
          </div>

          <div>
            <button nbButton appearance="ghost" [nbContextMenu]="personalMenu" nbContextMenuTag="personalMenu">
              <nb-user *ngIf="userInfo" [picture]="userInfo.picture" [name]="userInfo?.given_name||userInfo?.first_name"></nb-user>
              <nb-icon pack="fas" icon="caret-down"></nb-icon>
            </button>


          </div>
          </div>
        </div>
    </nb-layout-header>

    <nb-sidebar tag="main-sidebar" [state]="sideNavState">
      <div class="main-sidebar-loading-container" *ngIf="globalLeftMenuItems.length < 1">
          <i class="fas fa-spinner fa-spin" ></i>
        </div>

        <div class="main-sidebar-left-menu-items-container">
      <a *ngFor="let button of globalLeftMenuItems"
         class="left-menu-button"
         
         routerLinkActive="left-menu-button-active"
         nbButton
         fullWidth
         ghost
         tabIndex="-1"
         routerLink="{{button.link}}"
         
         >
        <div class="left-nav-item">
          <div class="left-nav-icon"><nb-icon pack="{{button.icon.pack}}" icon="{{button.icon.icon}}"></nb-icon></div>
          <div class="left-nav-label">{{button.translation_key||button.title|translation}}</div>
        </div>
      </a>
    </div>
      <div class="footer-menu">
        <div *ngFor="let menuItem of footerMenu">
          <a class="footer-menu-item" [routerLink]="menuItem.link" *ngIf="menuItem?.link;else modalclick">
            <i [ngClass]="menuItem.icon"></i>
            <span>{{menuItem.translation_key||menuItem.title|translation}}</span>
          </a>
          <ng-template #modalclick>
            <a class="footer-menu-item" (click)="openFooterModal(menuItem?.modal)">
              <i [ngClass]="menuItem.icon"></i>
              <span>{{menuItem.translation_key||menuItem.title|translation}}</span>

            </a>
          </ng-template>
        </div>
      </div>
    </nb-sidebar>
    <nb-layout-column class="scaffold-column">
      <div>
        <scaffold-notification-bar *ngFor="let notification of notificationService.barNotifications()|async" [notification]="notification"></scaffold-notification-bar>
      </div>
      <div class="app-body-content" (click)="closeProperties($event)">
        <div><router-outlet></router-outlet></div>

      </div>

      <div #modalViewRef></div>
    </nb-layout-column>
  </nb-layout>
</div>
